import { FieldRow, Form } from '@/components';
import { Col } from 'antd';
import { useEffect, memo } from 'react';
import { useCategoryLookupSource } from '../Categories.Common';
import { useFormikContext } from 'formik';
import * as yup from 'yup';
import styles from './PersonalizationSummary.module.scss';
import classNames from 'classnames';

interface Props {
  onSelect: (value?: string[]) => any;
  isPublic?: boolean;
  communityId: string;
}

const schema = yup.object({
  categoryIds: yup.array().of(yup.string().nullable().required()),
});

type FormType = yup.InferType<typeof schema>;

export function PersonalizationCategoriesSelectPanel(props: Props) {
  return (
    <Form.Formik<FormType>
      uid="public-categories"
      onSubmit={() => {}}
      initialValues={{ categoryIds: [] }}
      validationSchema={schema}
      i18n="personalization.summary"
    >
      <FieldRow>
        <Col span={8}>
          <CategorySelect {...props} />
        </Col>
      </FieldRow>
    </Form.Formik>
  );
}

const CategorySelect = memo(function CategorySelect(props: Props) {
  const { communityId, isPublic, onSelect } = props;

  const dataSource = useCategoryLookupSource({
    communityId,
    listed: true,
    allowAnonymous: isPublic,
  });

  const { values } = useFormikContext<FormType>();

  useEffect(() => {
    onSelect(values.categoryIds);
  }, [values.categoryIds, onSelect]);

  return (
    <Form.AsyncSelect
      dataSource={dataSource}
      name="categoryIds"
      mode="multiple"
      maxTagCount={3}
      maxTagTextLength={10}
      className={classNames('w-100', styles.typography)}
    />
  );
});
